module.exports = __webpack_public_path__ + "media/images/download-file-b58d5295.svg";